import { SalesDistributionService } from "app/modules/components/assistant/sales-distribution/sales-distribution.service";
import { ExportStoreService } from "../export-overlay.store";
import { ExportFileFormat, ExportRange } from "./core/export-task.enum";
import { IFilterMaterial } from "app/modules/components/assistant/sales-distribution/interfaces/filter_material.interface";
import { CombinedFilter } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { OrderAttributes } from "@albatrosdeveloper/ave-models-package";
import { map } from "rxjs";
import get from "lodash-es/get";
import { IMaterialListItem } from "app/modules/components/assistant/sales-distribution/interfaces/order_material.interface";
import { LegacyExportTask } from "./core/export-task-legacy";
import { IOptionFilterDistribution } from "app/modules/components/assistant/sales-distribution/interfaces/option_filter.interface";

export class SeleDstributionExport extends LegacyExportTask {
  constructor(
    itemCount: number,
    initialFilter: CombinedFilter<any>,
    private filter: IOptionFilterDistribution,
    range: ExportRange,
    format: ExportFileFormat,
    store: ExportStoreService,
    private saleDistributionService: SalesDistributionService,
    private option: string
  ) {
    super(
      "sales-distribution",
      "Distribición de ventas",
      itemCount,
      range,
      format,
      initialFilter,
      store
    );
  }

  private transformNatural(order: any, material: IMaterialListItem) {
    const dataFormat = {
      Codigo: get(order, "shipTo.externalKeys.code", "??"),
      Cliente: get(order, "shipTo.name", "??"),
      "Cod.Entrega": get(order, "soldTo.externalKeys.code", "??"),
      Entrega: get(order, "soldTo.name", "??"),
      "Cod.Material": get(material, "material.code", "??"),
      Material: get(material, "material.name", "??"),
      "U.M.":
        material.selected === 1
          ? get(material, "baseUnitOfMeasure.code", "??")
          : get(material, "pararellUnitOfMeasure.code", "??"),
      Precio: get(order, "unitPrice", "??"),
      "Cnt.Solicitada": get(order, "baseQuantity", "??"),
      "Cnt.Atendida": get(order, "soldQuantitySuggested", "0") || "0",
    };

    return dataFormat;
  }

  private transformObject(order: any, material: IMaterialListItem) {
    const dataFormat = {
      code: get(order, "shipTo.externalKeys.code", "??"),
      client: get(order, "shipTo.name", "??"),
      codeDelivery: get(order, "soldTo.externalKeys.code", "??"),
      delivery: get(order, "soldTo.name", "??"),
      codeMaterial: get(material, "material.code", "??"),
      material: get(material, "material.name", "??"),
      um:
        material.selected === 1
          ? get(material, "baseUnitOfMeasure.code", "??")
          : get(material, "pararellUnitOfMeasure.code", "??"),
      price: get(order, "unitPrice", "??"),
      amountRequest: get(order, "baseQuantity", "??"),
      amountSeved: get(order, "soldQuantitySuggested", "0") || "0",
    };

    return dataFormat;
  }

  /** The main method of the export task class. Called for each page. Here do the request, process
   * and transform the data. The result for each request after processed must be an object array,
   * this object array will be later transformed to a file (xlsx, csv, json) automatically. */
  override onRequest(currentFilter: CombinedFilter<any>) {
    // To avoid displaying the global loading screen, the header x-ave-ctx is sent with the request,
    // the http interceptor finds that the header is set as 'export' and ignores the request, so
    // won't display the loading screen.
    return this.saleDistributionService
      .findPaginationDistribution(this.filter, {
        contextHeader: "export",
      })
      .pipe(
        map((response) => {
          const res = response.data;

          const dataFile = [];

          const data = get(res, "materialList", []).map((item) =>
            get(item, "orderList", []).map((order) => {
              if (this.format === ExportFileFormat.JSON) {
                return this.transformObject(order, item);
              }

              return this.transformNatural(order, item);
            })
          );

          data.forEach((item) => dataFile.push(...item));

          return dataFile;
        })
      );
  }
}
